import { useUser } from '../../hooks/useUser';

export const useShowAdminModeToggle = () => {
  const { isEmployee } = useUser();

  if (!isEmployee) return false;

  return true;
};
